import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";

interface PassChangeReasonsToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
}

export const PassChangeReasonsToolbar = ({
	search,
	onSearchChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
}: PassChangeReasonsToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				mb: 1,
				p: 1,
				backgroundColor: "background.paper",
				borderRadius: 1,
			}}
		>
			<TextField
				size="small"
				placeholder="Search pass change reasons..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 250 }}
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
				sx={{ whiteSpace: "nowrap" }}
			>
				Add Reason
			</Button>
		</Box>
	);
};
